import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { LABELS, TITLES } from "common/lables";
import { CRM_REPORTS_APIs } from "apihandlers/crm/reports";
import { DateFunctions } from "common/datefunctions";
import { CRM_LEAD_STATUS, DOC_UPLOAD_STATUS, FORMATS } from "common/config";

const EXCEL_GRID_ID = "DocList";

const DocList = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        fromDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
        toDate: DateFunctions.getDate("thismonth", "to", FORMATS.SQL_DATE),
        // fromDate: "2023-06-01",
        // toDate: "2023-06-30",
      };
      const res: any = await CRM_REPORTS_APIs.getDocumentList(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;

        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;

          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          if (list[i]["verifiedStatus"]) {
            list[i]["verifiedStatus"] = "Yes";
          } else {
            list[i]["verifiedStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getDocumentList:", error);
    }
  };

  const COLUMNS = [
    {
      key: "crmLeadName",
      name: LABELS.LEAD_NAME,
      width: "20%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "leadSource",
      name: LABELS.LEAD_SOURCE,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "crmDocumentName",
      name: LABELS.DOCUMENT_NAME,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "uploadedOn",
      name: LABELS.UPLOADED_ON,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "uploadedBy",
      name: LABELS.UPLOADED_BY,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "updatedBy",
      name: LABELS.UPDATED_BY,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "mimeType",
      name: LABELS.MIME_TYPE,
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "areaName",
      name: LABELS.AREA_NAME,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "region",
      name: LABELS.REGION,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "regionZone",
      name: LABELS.REGION_ZONE,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "city",
      name: LABELS.CITY,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "centralZone",
      name: LABELS.CENTRAL_ZONE,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },

    {
      key: "country",
      name: LABELS.COUNTRY,
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "customerType",
      name: LABELS.CUSTOMER_TYPE,
      width: "12%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "leadStatus",
      name: LABELS.LEAD_STATUS,
      width: "10%",
      type: "dropdown",
      sortable: true,
      searchable: true,
      editable: false,
      filters: [
        {
          id: CRM_LEAD_STATUS.NEW_LEAD,
          name: CRM_LEAD_STATUS.NEW_LEAD,
        },
        {
          id: CRM_LEAD_STATUS.VERIFIED,
          name: CRM_LEAD_STATUS.VERIFIED,
        },
        {
          id: CRM_LEAD_STATUS.ASSIGNED,
          name: CRM_LEAD_STATUS.ASSIGNED,
        },
        {
          id: CRM_LEAD_STATUS.FIELD_VISIT,
          name: CRM_LEAD_STATUS.FIELD_VISIT,
        },
        {
          id: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
          name: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
        },
        {
          id: CRM_LEAD_STATUS.APPROVALS,
          name: CRM_LEAD_STATUS.APPROVALS,
        },
        {
          id: CRM_LEAD_STATUS.QUALIFIED,
          name: CRM_LEAD_STATUS.QUALIFIED,
        },
        {
          id: CRM_LEAD_STATUS.CONVERTED,
          name: CRM_LEAD_STATUS.CONVERTED,
        },
        {
          id: CRM_LEAD_STATUS.CUSTOMER,
          name: CRM_LEAD_STATUS.CUSTOMER,
        },
      ],
    },

    {
      key: "documentStatus",
      name: LABELS.DOCUMENT_STATUS,
      width: "10%",
      type: "dropdown",
      sortable: true,
      searchable: true,
      editable: false,

      filters: [
        {
          id: DOC_UPLOAD_STATUS.UPLOADED,
          name: DOC_UPLOAD_STATUS.UPLOADED,
        },
        {
          id: DOC_UPLOAD_STATUS.VERIFIED,
          name: DOC_UPLOAD_STATUS.VERIFIED,
        },
        {
          id: DOC_UPLOAD_STATUS.REJECTED,
          name: DOC_UPLOAD_STATUS.REJECTED,
        },
      ],
    },

    {
      key: "verifiedStatus",
      name: LABELS.VERIFIED_STATUS,
      width: "10%",
      type: "dropdown",
      sortable: true,
      searchable: true,
      editable: false,

      filters: [
        {
          id: "true",
          name: "TRUE",
        },
        {
          id: "false",
          name: "FALSE",
        },
      ],
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "8%",
      type: "dropdown",
      filters: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  console.log("selectedRow", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{TITLES.CRM_REPORTS}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.DOC_LIST}</li>
        </ul>
        <h4>{TITLES.DOC_LIST}</h4>
        {/* <p>{SUB_TITLES.DOC_LIST}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={EXCEL_GRID_ID}
            height={window.innerHeight * 0.85}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            hideUnhide={true}
            freezeColumn={true}
            newRowOption={false}
            exportName={TITLES.DOC_LIST}
            onReload={reloadGrid}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(DocList);
